<template>
  <div ref="dialogTootip" class="brand-training-page__main">
    <!--    <div class="training-logo">{{ this.$t("Training.brandTraining.title") }}</div>-->
    <div class="brand-training-breadcrumb">
      <a-breadcrumb>
        <a-breadcrumb-item>BeautyFluent</a-breadcrumb-item>
        <a-breadcrumb-item>{{ twoTextRouter }}</a-breadcrumb-item>
      </a-breadcrumb>
    </div>
    <div class="training-page-menu">
      <brandMenu :current="menuTab" :is-brand="true" @clickToNewTab="clickToNewTab"></brandMenu>
    </div>
    <div v-if="routerTabTaxt === 'product'" class="training-page-content">
      <BrandProduct :table-date="tableDate" :show-share-btn="showShareBtn" :get-training-products="getTrainingProducts"
        :download-text="downloadText" :share-text="shareText" :clipboard="clipboard"
        @updateNewTrainingList="updateNewTrainingList" @jumpToCreateTraining="jumpToCreateTraining"
        @handleProductList="handleProductList" @showModalNoInfo="showModalNoInfo" @shareToLink="shareToLink"
        @downloadQRCode="downloadQRCode"></BrandProduct>
    </div>
    <div v-else-if="routerTabTaxt === 'reporting'">
      <section class="page-placeholder hero is-medium is-light is-bold parent-view-content">
        <iframe id="frame2" :src='iframeURL' display="block" name="frame2" scrolling="auto" allowtransparency="false"
          height="100%" width="100%" class="frame-container"></iframe>
      </section>
    </div>
    <div v-else-if="routerTabTaxt === 'retailers'" class="training-page-content">
      <BrandTrainingRetailersTable v-if="!isShowPlanStep && tableDate && tableDate.length > 0" :table-date="tableDate"
        :show-share-btn="showShareBtn" @addNewRetailerStep="showSubcribePlanStep"
        @viewRetailerItemProduct="viewRetailerItemProduct" @updateTrainingRetailer="updateTrainingRetailer"
        @addNewRetailer="addNewRetailer"></BrandTrainingRetailersTable>
      <!-- <BeautyFluentPlanStep
        v-else
        :is-brand="true"
        :is-has-general="hasGeneralRetailer"
        :existed-retailer="tableDate"
        :is-sign-up="false"
        @subscribe="success"
        @success="success"
        @clickHereAction="clickToBrandUpgrade"
      /> -->
      <RegistrationBrand v-else :is-required-sign-up="false" @success="success" :brand-id="userId"></RegistrationBrand>
    </div>
    <ShareLink ref="shareLink"></ShareLink>
    <BrandTableDialog ref="brandTableDialog"></BrandTableDialog>
    <a-modal v-model="sureVisible" :centered="true" :footer="null" :width="464"
      :get-container="() => $refs.dialogTootip" :title="null">
      <span slot="closeIcon">
        <a-icon type="close-circle" style="font-size: 21px" />
      </span>
      <div class="dialog-info-before-submit">
        <p class="dialog-info-title">BUT FIRST!</p>
        <p class="dialog-content-style">
          We recently updated our training tool to automatically import key
          benefits from your product catalog. Make sure your product pages are
          updated with key benefits before you begin to ensure your training
          sheets can be published.
        </p>
        <p class="dialog-close-btn" @click="SubmitDialog">
          Update Your Product Catalog
        </p>
      </div>
    </a-modal>
    <upLoadVideoDialog ref="uploadVideo" @sendSuccess="sendSuccess"></upLoadVideoDialog>
    <AddRetailerStepOne ref="AddRetailerStepOne" @updateStepStatus="updateStepStatus"></AddRetailerStepOne>
    <AddRetailerStepTwo ref="AddRetailerStepTwo" @updateStepStatus="updateStepStatus"></AddRetailerStepTwo>
    <AddRetailerStepThree ref="AddRetailerStepThree" @backToDialog="backToDialog"
      @updatePaymentTrainingSubscription="updatePaymentTrainingSubscription"></AddRetailerStepThree>
    <addRetailerPurchase ref="addRetailerPurchase" @doPurchase="doPurchase"></addRetailerPurchase>
    <retailerItemProduct ref="retailerItemProduct" @updateRetailerInfo="viewRetailerItemProduct"
      @updateRetailerList="updateRetailerList"></retailerItemProduct>
    <AdminTrainintRetailerBrandProductDialog ref="modifyRetailerBrandProduct"
      @updateNewTrainingList="updateNewTrainingList"></AdminTrainintRetailerBrandProductDialog>
    <ProductViewDialogNew ref="ProductViewDialogNew"></ProductViewDialogNew>
    <membershipExpiringDialog ref="membershipExpiringDialog" @addCardList="openAddMoreCardDialog">
    </membershipExpiringDialog>
    <addNewCardDialog ref="addNewCardDialog" @openAddMoreCardDialog="openAddMoreCardDialog"></addNewCardDialog>
    <cardListDialog ref="cardListDialog" @openAddPaymentDialog="openAddPaymentDialog"></cardListDialog>
    <a-modal :visible="showVisible" :footer="null" :destroy-on-close="true" :body-style="{ padding: 15 }"
      :get-container="() => $refs.dialogTootip" @cancel="handleCancel">
      <div class="can-not-create-training">
        <p class="title-error-text">
          <a-icon type="exclamation-circle" style="color: #faad14; margin-right: 5px;font-size: 18px" />Please modify
          the details of the product
        </p>
        <p>{{ contentText }}</p>
        <div class="button-style">
          <a-button class="btn-style" @click="jumpToBrandProduct">
            <!--            {{ this.$t("Training.brandTraining.createButton") }}-->
            To modify
          </a-button>
        </div>
      </div>
    </a-modal>
    <a-modal :visible="showAddRetasilerVisible" :footer="null" :destroy-on-close="true" :body-style="{ padding: 15 }"
      :get-container="() => $refs.dialogTootip" @cancel="handleAddRetailerCancel">
      <div class="can-not-create-training">
        <p class="title-error-text">
          <a-icon type="exclamation-circle" style="color: #faad14; margin-right: 5px;font-size: 18px" />warning
        </p>
        <p style="padding-left: 20px">
          You have not added your bank card, please add.
        </p>
        <div class="button-style">
          <a-button class="btn-style" @click="handleAddRetailerCancel">
            <!--            {{ this.$t("Training.brandTraining.createButton") }}-->
            OK
          </a-button>
        </div>
      </div>
    </a-modal>
    <UpgradePlanDialog ref="brandSettingUpgradePlanDialog" :brand-type="brandType" />
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import trainingClient from "@/api/training-client";
import { setSesStorage, getSesStorage } from "@/utils/storageUtil";
import ShareLink from "@/components/training/shareLinkDialog";
import BrandTableDialog from "@/components/brands/mainPage/components/BrandTableDialog";
import upLoadVideoDialog from "@/components/training/upLoadVideoDialog";
import brandMenu from "@/components/training/__components/brandRetailerMenu";
import BrandTrainingRetailersTable from "@/components/training/brandTrainingRetailerTable";
import AddRetailerStepOne from "@/components/training/__components/brandTrainingRetailerAddStep1Dialog";
import AddRetailerStepTwo from "@/components/training/__components/brandTrainingRetailerAddStep2Dialog";
import AddRetailerStepThree from "@/components/training/__components/brandTrainingRetailerAddStep3Dialog";
import addRetailerPurchase from "@/components/training/__components/addNewRetailerPurchase";
import retailerItemProduct from "@/components/training/__components/retailerItemProduct";
import AdminTrainintRetailerBrandProductDialog from "@/components/admin/AdminProductTrainingDialog";
import ProductViewDialogNew from "@/components/training/__components/productViewDialogNew";
import membershipExpiringDialog from "@/components/webflowComponent/MembershipExpiringDialog";
import addNewCardDialog from "@/components/brands/settings/addPaymentCardDialog";
import cardListDialog from "@/components/brands/settings/addMoreCardDialog";
import constants from "@/config";
import Clipboard from "clipboard";
//import BeautyFluentPlanStep from "@/views/BrandBFRegistrationStepOne";
import RegistrationBrand from "@/views/Registrations/BrandRegistration";
import UpgradePlanDialog from "@/components/shared/UpgradePlanDialog";
import BrandProduct from "@/components/training/brandTraining/brandProduct";
import { downloadQR } from "@/utils/validate";

export default {
  name: "BrandCreateTraining",
  components: {
    ShareLink,
    BrandTableDialog,
    brandMenu,
    BrandTrainingRetailersTable,
    AddRetailerStepOne,
    AddRetailerStepTwo,
    AddRetailerStepThree,
    addRetailerPurchase,
    retailerItemProduct,
    ProductViewDialogNew,
    AdminTrainintRetailerBrandProductDialog,
    upLoadVideoDialog,
    membershipExpiringDialog,
    addNewCardDialog,
    BrandProduct,
    cardListDialog,
    //BeautyFluentPlanStep,
    RegistrationBrand,
    UpgradePlanDialog,
  },
  props: {
    retailerId: { type: String, default: "" },
  },
  data() {
    return {
      isUpdating: false,
      shareVisibile: false,
      showVisible: false,
      showAddRetasilerVisible: false,
      contentText: "",
      contentLinkId: "",
      drag: false,
      tableDate: [],
      isDetele: false,
      publicTab: false,
      list: [],
      defaultPage: 1,
      pageCurrent: 17,
      sureVisible: false,
      userId: undefined,
      menuTab: "",
      typeMoney: "",
      addRetailerSelectArr: [],
      downloadText: "Download QR code",
      shareText: "Share Link",
      clipboard: null,
      isNameSort: false,
      isHeroSort: false,
      isSkuSort: false,
      isUpcSort: false,
      isModifiedSort: false,
      currentNum: 50,
      canNotDrag: 0,
      isShowPlanStep: false,
      hasGeneralRetailer: false,
      iframeURL: ''
    };
  },
  computed: {
    ...mapState({
      userName: (state) => state.brand.brand.shortName,
    }),
    // ...mapState({
    //   userId: state => state.user.businessId
    // }),
    ...mapGetters({
      getTrainingProducts: "training/getTrainingProducts",
    }),
    // If no data is displayed this button
    showShareBtn() {
      return this.getTrainingProducts && this.getTrainingProducts.length !== 0;
    },
    deleteText() {
      return this.$t("ButtonText.delete");
    },
    editText() {
      return this.$t("ButtonText.edit");
    },
    brand() {
      return this.$store.getters["brand/brand"];
    },
    role() {
      return this.$store.getters["user/role"];
    },
    isBrand() {
      return (
        this.role === "brand" ||
        constants.adminBrandRoutes.includes(this.$route.name)
      );
    },
    isAdmin() {
      return this.$store.getters["user/isAdmin"];
    },
    brandType() {
      return (
        this.brand &&
        this.brand.subscriptions &&
        this.brand.subscriptions.length > 0 &&
        this.brand.subscriptions[0].type &&
        this.brand.subscriptions[0].type.id
      );
    },
    twoTextRouter() {
      if (this.$route.query.tab === "product") {
        return "Product";
      } else if (this.$route.query.tab === "retailers") {
        return "Retailers";
      } else {
        return "Reporting";
      }
    },
    copyText() {
      // return `${window.location.origin}/TrainingProductViewAll?id=${this.userId}&name=${this.userName}`
      return `${window.location.origin}/training/${this.userName}`;
    },
    routerTabTaxt() {
      return this.$route.query.tab;
    },
  },
  watch: {
    async $route() {
      this.menuTab = this.$route.query.tab;
      this.initCopyBtn();
      await this.updateNewTrainingList();
    },
  },
  created() {
    this.userId = this.$route.params.brandId
      ? this.$route.params.brandId
      : this.$store.getters["user/businessId"];
    this.menuTab = this.$route.query.tab || "product";
    this.isShowPlanStep = this.$route.query.isAddRetailer || false;
    this.iframeURL = this.getIFrameURL(this.brand.name);
  },
  // async watch() {
  //   console.log(22222)
  //   this.menuTab = this.$route.query.tab
  //   this.initCopyBtn()
  //   await this.$store.dispatch("brandPayment/fetchCards", this.brand.id)
  //   await this.$store.dispatch("reference/setReference")
  // },
  async mounted() {
    this.userId = this.$route.params.brandId
      ? this.$route.params.brandId
      : this.$store.getters["user/businessId"];
    this.menuTab = this.$route.query.tab;
    this.isShowPlanStep = this.$route.query.isAddRetailer || false;
    if (this.brandType === "basic" && this.isBrand) {
      this.$refs["membershipExpiringDialog"].openDialog();
      return;
    } else if (this.$route.query.main && this.$route.query.tab === "product") {
      this.sureVisible = true;
    }
    await this.updateNewTrainingList();
    if (this.brandType === "basic") {
      return;
    }
    this.initCopyBtn();
    await this.$store.dispatch("brandPayment/fetchCards", this.brand.id);
    await this.$store.dispatch("reference/setReference");
  },
  destroyed() {
    if (this.clipboard && this.shareVisible) {
      this.clipboard.destroyed();
    }
  },
  methods: {
    ...mapActions({
      getProductList: "training/getProductList",
      getProductListSort: "training/getProductListSort",
      getProducts: "training/getProducts",
      deleteProduct: "training/deleteProduct",
      // getRetailersList: "training/getRetailersTableList",
      getRetailersList: "training/getBrandTraining",
      updateRetailer: "training/updateTrainingRetailer",
      updatePaymentTrainingSub: "training/updatePaymentTrainingSubscription",
    }),
    getIFrameURL(brandName) {
      return `https://analytics.beautyfluent.keithgdavis.com/app/dashboards?auth_provider_hint=anonymous1#/view/84cc70a0-d410-11ee-9080-91161741d283?embed=true&_g=(filters:!())&_a=(controlGroupInput:(chainingSystem:HIERARCHICAL,controlStyle:oneLine,defaultControlGrow:!t,defaultControlWidth:medium,ignoreParentSettings:(ignoreFilters:!f,ignoreQuery:!f,ignoreTimerange:!f,ignoreValidations:!f),panels:(a01fa95f-e1c2-4770-b193-b3f261fd1fc0:(explicitInput:(dataViewId:ead7bf06-990a-4b13-80d6-f3099a899ac8,enhancements:(),fieldName:fields.UserInfo.RetailerName.keyword,id:a01fa95f-e1c2-4770-b193-b3f261fd1fc0,parentFieldName:fields.UserInfo.RetailerName,selectedOptions:!(),singleSelect:!f,title:Retailer),grow:!f,order:0,type:optionsListControl,width:medium))),description:'',filters:!(),fullScreenMode:!f,options:(hidePanelTitles:!f,syncColors:!f,syncTooltips:!f,useMargins:!t),panels:!((embeddableConfig:(enhancements:(),hidePanelTitles:!t,savedVis:(data:(aggs:!(),searchSource:(filter:!(),query:(language:kuery,query:''))),description:'',id:'',params:(fontSize:24,markdown:'Your%20Engagement',openLinksInNewTab:!f),title:'',type:markdown,uiState:())),gridData:(h:4,i:'8adc8556-6d54-45ab-aa8c-7dba6fc8a7ed',w:48,x:0,y:0),panelIndex:'8adc8556-6d54-45ab-aa8c-7dba6fc8a7ed',type:visualization,version:'8.5.1'),(embeddableConfig:(enhancements:(),hidePanelTitles:!f),gridData:(h:13,i:fa15cca8-38e0-42e8-9a78-c79e9cd8c1c1,w:48,x:0,y:4),id:'72edc1e0-ba48-11ee-9080-91161741d283',panelIndex:fa15cca8-38e0-42e8-9a78-c79e9cd8c1c1,title:'Engagement%20Summary:%20Total%20Daily%20Views',type:lens,version:'8.5.1'),(embeddableConfig:(attributes:(references:!((id:ead7bf06-990a-4b13-80d6-f3099a899ac8,name:indexpattern-datasource-layer-1b96668e-a8ce-4666-8961-02ae6fbcf588,type:index-pattern),(id:ead7bf06-990a-4b13-80d6-f3099a899ac8,name:'5c3bf0b4-6a18-4581-8cb5-facc6ff1d916',type:index-pattern),(id:ead7bf06-990a-4b13-80d6-f3099a899ac8,name:de0824e7-8387-4af7-9be4-1fd92382a94e,type:index-pattern)),state:(adHocDataViews:(),datasourceStates:(indexpattern:(layers:('1b96668e-a8ce-4666-8961-02ae6fbcf588':(columnOrder:!(a2753e88-3fcc-4724-af1b-3564db43ba6d,a2753e88-3fcc-4724-af1b-3564db43ba6dX0),columns:(a2753e88-3fcc-4724-af1b-3564db43ba6d:(customLabel:!t,dataType:number,isBucketed:!f,label:Stores,operationType:formula,params:(formula:'unique_count(fields.UserInfo.RetailerLocationCity.keyword)',isFormulaBroken:!f),references:!(a2753e88-3fcc-4724-af1b-3564db43ba6dX0),scale:ratio),a2753e88-3fcc-4724-af1b-3564db43ba6dX0:(customLabel:!t,dataType:number,isBucketed:!f,label:'Part%20of%20Stores',operationType:unique_count,params:(emptyAsNull:!f),scale:ratio,sourceField:fields.UserInfo.RetailerLocationCity.keyword)),incompleteColumns:())))),filters:!(('$state':(store:appState),meta:(alias:!n,disabled:!f,index:'5c3bf0b4-6a18-4581-8cb5-facc6ff1d916',key:fields.UserInfo.RetailerLocationCity.keyword,negate:!f,type:exists,value:exists),query:(exists:(field:fields.UserInfo.RetailerLocationCity.keyword))),('$state':(store:appState),meta:(alias:!n,disabled:!f,index:de0824e7-8387-4af7-9be4-1fd92382a94e,key:fields.UserInfo.RetailerName.keyword,negate:!t,params:!('Demo%20-%20Retailer','Not%20Listed'),type:phrases,value:!('Demo%20-%20Retailer','Not%20Listed')),query:(bool:(minimum_should_match:1,should:!((match_phrase:(fields.UserInfo.RetailerName.keyword:'Demo%20-%20Retailer')),(match_phrase:(fields.UserInfo.RetailerName.keyword:'Not%20Listed'))))))),internalReferences:!(),query:(language:lucene,query:''),visualization:(accessor:a2753e88-3fcc-4724-af1b-3564db43ba6d,colorMode:Background,layerId:'1b96668e-a8ce-4666-8961-02ae6fbcf588',layerType:data,palette:(name:custom,params:(colorStops:!((color:%23ff4f40cc,stop:!n)),continuity:all,maxSteps:5,name:custom,progression:fixed,rangeMax:!n,rangeMin:!n,rangeType:number,reverse:!f,steps:3,stops:!((color:%23ff4f40cc,stop:852))),type:palette))),title:'',type:lens,visualizationType:lnsLegacyMetric),enhancements:(),hidePanelTitles:!t),gridData:(h:8,i:'51d6118c-f169-4470-a02f-9eb4c54e1b4d',w:7,x:0,y:17),panelIndex:'51d6118c-f169-4470-a02f-9eb4c54e1b4d',title:'Total%20number%20of%20stores%20with%20app%20visibility%20',type:lens,version:'8.5.1'),(embeddableConfig:(attributes:(references:!((id:ead7bf06-990a-4b13-80d6-f3099a899ac8,name:indexpattern-datasource-layer-763b49b8-84e5-45d9-85ae-b1fe402cf186,type:index-pattern),(id:ead7bf06-990a-4b13-80d6-f3099a899ac8,name:'5895ddb7-e520-4b9d-acbf-8ab288aba840',type:index-pattern),(id:ead7bf06-990a-4b13-80d6-f3099a899ac8,name:'8ad47c32-00bf-4d0e-8f88-9c14895f5a60',type:index-pattern),(id:ead7bf06-990a-4b13-80d6-f3099a899ac8,name:cfe1d2a0-f3b2-4434-9496-f8c05ce1b414,type:index-pattern)),state:(adHocDataViews:(),datasourceStates:(indexpattern:(layers:('763b49b8-84e5-45d9-85ae-b1fe402cf186':(columnOrder:!('510074f5-2eff-4a17-b79c-2e3a6b940ce5'),columns:('510074f5-2eff-4a17-b79c-2e3a6b940ce5':(customLabel:!t,dataType:number,isBucketed:!f,label:'Page%20Views',operationType:count,params:(emptyAsNull:!t),scale:ratio,sourceField:___records___)),incompleteColumns:())))),filters:!(('$state':(store:appState),meta:(alias:!n,disabled:!f,index:'5895ddb7-e520-4b9d-acbf-8ab288aba840',key:fields.LogAction.keyword,negate:!f,params:(query:View),type:phrase),query:(match_phrase:(fields.LogAction.keyword:View))),('$state':(store:appState),meta:(alias:!n,disabled:!f,index:'8ad47c32-00bf-4d0e-8f88-9c14895f5a60',key:fields.UserInfo.RetailerName.keyword,negate:!t,params:!('Demo%20-%20Retailer','Not%20Listed'),type:phrases,value:!('Demo%20-%20Retailer','Not%20Listed')),query:(bool:(minimum_should_match:1,should:!((match_phrase:(fields.UserInfo.RetailerName.keyword:'Demo%20-%20Retailer')),(match_phrase:(fields.UserInfo.RetailerName.keyword:'Not%20Listed')))))),('$state':(store:appState),meta:(alias:!n,disabled:!f,index:cfe1d2a0-f3b2-4434-9496-f8c05ce1b414,key:fields.UserInfo.RetailerLocationCity,negate:!f,type:exists,value:exists),query:(exists:(field:fields.UserInfo.RetailerLocationCity)))),internalReferences:!(),query:(language:lucene,query:''),visualization:(accessor:'510074f5-2eff-4a17-b79c-2e3a6b940ce5',colorMode:Background,layerId:'763b49b8-84e5-45d9-85ae-b1fe402cf186',layerType:data,palette:(name:custom,params:(colorStops:!((color:%23FDF0F0,stop:!n)),continuity:all,maxSteps:5,name:custom,progression:fixed,rangeMax:!n,rangeMin:!n,rangeType:number,reverse:!f,steps:3,stops:!((color:%23FDF0F0,stop:4970))),type:palette))),title:'',type:lens,visualizationType:lnsLegacyMetric),enhancements:(),hidePanelTitles:!t),gridData:(h:8,i:aed67143-9fb4-45b1-9018-ee4733fc1a41,w:7,x:7,y:17),panelIndex:aed67143-9fb4-45b1-9018-ee4733fc1a41,title:'Total%20app%20pages%20visited',type:lens,version:'8.5.1'),(embeddableConfig:(attributes:(references:!((id:ead7bf06-990a-4b13-80d6-f3099a899ac8,name:indexpattern-datasource-layer-03d44bbf-a6a6-44c1-aa62-df28c62b3239,type:index-pattern),(id:ead7bf06-990a-4b13-80d6-f3099a899ac8,name:e12d8138-027f-436b-976b-042ad62b9bcc,type:index-pattern),(id:ead7bf06-990a-4b13-80d6-f3099a899ac8,name:'7163aae0-e748-4485-99f5-b892f1fa7ab3',type:index-pattern),(id:ead7bf06-990a-4b13-80d6-f3099a899ac8,name:'442ae35a-6ef4-44d2-949f-152b54b92f5b',type:index-pattern)),state:(adHocDataViews:(),datasourceStates:(indexpattern:(layers:('03d44bbf-a6a6-44c1-aa62-df28c62b3239':(columnOrder:!(a9ced623-d515-4811-a394-0a043b043ac7,a9ced623-d515-4811-a394-0a043b043ac7X0),columns:(a9ced623-d515-4811-a394-0a043b043ac7:(customLabel:!t,dataType:number,isBucketed:!f,label:Scans,operationType:formula,params:(formula:'count()',isFormulaBroken:!f),references:!(a9ced623-d515-4811-a394-0a043b043ac7X0),scale:ratio),a9ced623-d515-4811-a394-0a043b043ac7X0:(customLabel:!t,dataType:number,isBucketed:!f,label:'Part%20of%20Scans',operationType:count,params:(emptyAsNull:!f),scale:ratio,sourceField:___records___)),incompleteColumns:())))),filters:!(('$state':(store:appState),meta:(alias:!n,disabled:!f,index:e12d8138-027f-436b-976b-042ad62b9bcc,key:fields.LogAction.keyword,negate:!f,params:(query:Scan),type:phrase),query:(match_phrase:(fields.LogAction.keyword:Scan))),('$state':(store:appState),meta:(alias:!n,disabled:!f,index:'7163aae0-e748-4485-99f5-b892f1fa7ab3',key:fields.UserInfo.RetailerName.keyword,negate:!t,params:!('Demo%20-%20Retailer','Not%20Listed'),type:phrases,value:!('Demo%20-%20Retailer','Not%20Listed')),query:(bool:(minimum_should_match:1,should:!((match_phrase:(fields.UserInfo.RetailerName.keyword:'Demo%20-%20Retailer')),(match_phrase:(fields.UserInfo.RetailerName.keyword:'Not%20Listed')))))),('$state':(store:appState),meta:(alias:!n,disabled:!f,index:'442ae35a-6ef4-44d2-949f-152b54b92f5b',key:fields.UserInfo.RetailerLocationCity.keyword,negate:!f,type:exists,value:exists),query:(exists:(field:fields.UserInfo.RetailerLocationCity.keyword)))),internalReferences:!(),query:(language:lucene,query:''),visualization:(accessor:a9ced623-d515-4811-a394-0a043b043ac7,colorMode:Background,layerId:'03d44bbf-a6a6-44c1-aa62-df28c62b3239',layerType:data,palette:(name:custom,params:(colorStops:!((color:%23FDF0F0,stop:!n)),continuity:all,maxSteps:5,name:custom,progression:fixed,rangeMax:!n,rangeMin:!n,rangeType:number,reverse:!f,steps:3,stops:!((color:%23FDF0F0,stop:1162))),type:palette))),title:'',type:lens,visualizationType:lnsLegacyMetric),enhancements:(),hidePanelTitles:!t),gridData:(h:8,i:af9710a3-91c3-4b86-9fe4-f523cace463d,w:7,x:14,y:17),panelIndex:af9710a3-91c3-4b86-9fe4-f523cace463d,title:'Number%20of%20times%20your%20products%20were%20scaned',type:lens,version:'8.5.1'),(embeddableConfig:(attributes:(references:!((id:ead7bf06-990a-4b13-80d6-f3099a899ac8,name:indexpattern-datasource-layer-12962f15-3dee-4c9c-a24d-8f4934fe3ec1,type:index-pattern),(id:ead7bf06-990a-4b13-80d6-f3099a899ac8,name:'5b00db97-77cd-46a0-9619-a2d1c35eea38',type:index-pattern),(id:ead7bf06-990a-4b13-80d6-f3099a899ac8,name:'94acb0e8-6f5a-4ffd-95ca-33d65d856ca5',type:index-pattern),(id:ead7bf06-990a-4b13-80d6-f3099a899ac8,name:'4e5a4085-b04a-4311-abfb-3d221dbbf7bf',type:index-pattern)),state:(adHocDataViews:(),datasourceStates:(indexpattern:(layers:('12962f15-3dee-4c9c-a24d-8f4934fe3ec1':(columnOrder:!('059c0865-59bc-4edf-b435-586343ea71ee','059c0865-59bc-4edf-b435-586343ea71eeX0'),columns:('059c0865-59bc-4edf-b435-586343ea71ee':(customLabel:!t,dataType:number,isBucketed:!f,label:Searches,operationType:formula,params:(formula:'count()',isFormulaBroken:!f),references:!('059c0865-59bc-4edf-b435-586343ea71eeX0'),scale:ratio),'059c0865-59bc-4edf-b435-586343ea71eeX0':(customLabel:!t,dataType:number,isBucketed:!f,label:'Part%20of%20Searches',operationType:count,params:(emptyAsNull:!f),scale:ratio,sourceField:___records___)),incompleteColumns:())))),filters:!(('$state':(store:appState),meta:(alias:!n,disabled:!f,index:'5b00db97-77cd-46a0-9619-a2d1c35eea38',key:fields.ClientLog.context.keyword,negate:!f,params:(query:searchSelection),type:phrase),query:(match_phrase:(fields.ClientLog.context.keyword:searchSelection))),('$state':(store:appState),meta:(alias:!n,disabled:!f,index:'94acb0e8-6f5a-4ffd-95ca-33d65d856ca5',key:fields.UserInfo.RetailerLocationCity.keyword,negate:!f,type:exists,value:exists),query:(exists:(field:fields.UserInfo.RetailerLocationCity.keyword))),('$state':(store:appState),meta:(alias:!n,disabled:!f,index:'4e5a4085-b04a-4311-abfb-3d221dbbf7bf',key:fields.UserInfo.RetailerName.keyword,negate:!t,params:!('Demo%20-%20Retailer','Not%20Listed'),type:phrases,value:!('Demo%20-%20Retailer','Not%20Listed')),query:(bool:(minimum_should_match:1,should:!((match_phrase:(fields.UserInfo.RetailerName.keyword:'Demo%20-%20Retailer')),(match_phrase:(fields.UserInfo.RetailerName.keyword:'Not%20Listed'))))))),internalReferences:!(),query:(language:lucene,query:''),visualization:(accessor:'059c0865-59bc-4edf-b435-586343ea71ee',colorMode:Background,layerId:'12962f15-3dee-4c9c-a24d-8f4934fe3ec1',layerType:data,palette:(name:custom,params:(colorStops:!((color:%23FDF0F0,stop:!n)),continuity:all,maxSteps:5,name:custom,progression:fixed,rangeMax:!n,rangeMin:!n,rangeType:number,reverse:!f,steps:3,stops:!((color:%23FDF0F0,stop:828))),type:palette))),title:'',type:lens,visualizationType:lnsLegacyMetric),enhancements:(),hidePanelTitles:!t),gridData:(h:8,i:df86700d-0dee-4db5-8e82-1009386620aa,w:7,x:21,y:17),panelIndex:df86700d-0dee-4db5-8e82-1009386620aa,title:'Searches%20where%20your%20brand%20was%20suggested',type:lens,version:'8.5.1'),(embeddableConfig:(attributes:(references:!((id:ead7bf06-990a-4b13-80d6-f3099a899ac8,name:indexpattern-datasource-layer-d70cbc72-4f3f-4ecc-9fdf-f7b725393b52,type:index-pattern),(id:ead7bf06-990a-4b13-80d6-f3099a899ac8,name:cd0d01a2-f710-45ef-b868-d9af49cc1566,type:index-pattern),(id:ead7bf06-990a-4b13-80d6-f3099a899ac8,name:'0aaffab1-f516-494a-85cd-5f321f866618',type:index-pattern),(id:ead7bf06-990a-4b13-80d6-f3099a899ac8,name:fb033dca-5199-4443-a485-ad4931a21516,type:index-pattern)),state:(adHocDataViews:(),datasourceStates:(indexpattern:(layers:(d70cbc72-4f3f-4ecc-9fdf-f7b725393b52:(columnOrder:!('0062d51a-628e-493c-bc72-43fb70ead4cb'),columns:('0062d51a-628e-493c-bc72-43fb70ead4cb':(customLabel:!t,dataType:number,isBucketed:!f,label:Bookmarks,operationType:count,params:(emptyAsNull:!t),scale:ratio,sourceField:___records___)),incompleteColumns:())))),filters:!(('$state':(store:appState),meta:(alias:!n,disabled:!f,index:cd0d01a2-f710-45ef-b868-d9af49cc1566,key:fields.ClientLog.context.keyword,negate:!f,params:(query:itemFavorited),type:phrase),query:(match_phrase:(fields.ClientLog.context.keyword:itemFavorited))),('$state':(store:appState),meta:(alias:!n,disabled:!f,index:'0aaffab1-f516-494a-85cd-5f321f866618',key:fields.UserInfo.RetailerLocationCity.keyword,negate:!f,type:exists,value:exists),query:(exists:(field:fields.UserInfo.RetailerLocationCity.keyword))),('$state':(store:appState),meta:(alias:!n,disabled:!f,index:fb033dca-5199-4443-a485-ad4931a21516,key:fields.UserInfo.RetailerName.keyword,negate:!t,params:!('Demo%20-%20Retailer','Not%20Listed'),type:phrases,value:!('Demo%20-%20Retailer','Not%20Listed')),query:(bool:(minimum_should_match:1,should:!((match_phrase:(fields.UserInfo.RetailerName.keyword:'Demo%20-%20Retailer')),(match_phrase:(fields.UserInfo.RetailerName.keyword:'Not%20Listed'))))))),internalReferences:!(),query:(language:lucene,query:''),visualization:(accessor:'0062d51a-628e-493c-bc72-43fb70ead4cb',colorMode:Background,layerId:d70cbc72-4f3f-4ecc-9fdf-f7b725393b52,layerType:data,palette:(name:custom,params:(colorStops:!((color:%23FDF0F0,stop:!n)),continuity:all,maxSteps:5,name:custom,progression:fixed,rangeMax:!n,rangeMin:!n,rangeType:number,reverse:!f,steps:3,stops:!((color:%23FDF0F0,stop:22))),type:palette))),title:'',type:lens,visualizationType:lnsLegacyMetric),enhancements:(),hidePanelTitles:!t),gridData:(h:8,i:'86108b15-8f55-4d4f-8e67-b8d4815d0148',w:7,x:28,y:17),panelIndex:'86108b15-8f55-4d4f-8e67-b8d4815d0148',title:'Number%20of%20times%20your%20products%20were%20saved',type:lens,version:'8.5.1'),(embeddableConfig:(attributes:(references:!((id:ead7bf06-990a-4b13-80d6-f3099a899ac8,name:indexpattern-datasource-layer-8d30f2a6-3fc4-4ed5-b450-4b10325090e9,type:index-pattern),(id:ead7bf06-990a-4b13-80d6-f3099a899ac8,name:d3c7973f-a2f2-43e0-9e2a-e78c0103a37e,type:index-pattern),(id:ead7bf06-990a-4b13-80d6-f3099a899ac8,name:b0dfd6a8-ebc6-4008-9537-ed9321e121ad,type:index-pattern),(id:ead7bf06-990a-4b13-80d6-f3099a899ac8,name:d4a85eaa-c2db-4754-badd-2f5c4fa2d4a2,type:index-pattern)),state:(adHocDataViews:(),datasourceStates:(indexpattern:(layers:('8d30f2a6-3fc4-4ed5-b450-4b10325090e9':(columnOrder:!(e2e73996-aa04-4c76-ab0f-4222dca384b7),columns:(e2e73996-aa04-4c76-ab0f-4222dca384b7:(customLabel:!t,dataType:number,isBucketed:!f,label:'Video%20Views',operationType:count,params:(emptyAsNull:!t),scale:ratio,sourceField:___records___)),incompleteColumns:())))),filters:!(('$state':(store:appState),meta:(alias:!n,disabled:!f,index:d3c7973f-a2f2-43e0-9e2a-e78c0103a37e,key:fields.ClientLog.context.keyword,negate:!f,params:(query:productVideoWatched),type:phrase),query:(match_phrase:(fields.ClientLog.context.keyword:productVideoWatched))),('$state':(store:appState),meta:(alias:!n,disabled:!f,index:b0dfd6a8-ebc6-4008-9537-ed9321e121ad,key:fields.UserInfo.RetailerLocationCity.keyword,negate:!f,type:exists,value:exists),query:(exists:(field:fields.UserInfo.RetailerLocationCity.keyword))),('$state':(store:appState),meta:(alias:!n,disabled:!f,index:d4a85eaa-c2db-4754-badd-2f5c4fa2d4a2,key:fields.UserInfo.RetailerName.keyword,negate:!t,params:!('Demo%20-%20Retailer','Not%20Listed'),type:phrases,value:!('Demo%20-%20Retailer','Not%20Listed')),query:(bool:(minimum_should_match:1,should:!((match_phrase:(fields.UserInfo.RetailerName.keyword:'Demo%20-%20Retailer')),(match_phrase:(fields.UserInfo.RetailerName.keyword:'Not%20Listed'))))))),internalReferences:!(),query:(language:lucene,query:''),visualization:(accessor:e2e73996-aa04-4c76-ab0f-4222dca384b7,colorMode:Background,layerId:'8d30f2a6-3fc4-4ed5-b450-4b10325090e9',layerType:data,palette:(name:custom,params:(colorStops:!((color:%23FDF0F0,stop:!n)),continuity:all,maxSteps:5,name:custom,progression:fixed,rangeMax:!n,rangeMin:!n,rangeType:number,reverse:!f,steps:3,stops:!((color:%23FDF0F0,stop:2))),type:palette))),title:'',type:lens,visualizationType:lnsLegacyMetric),enhancements:(),hidePanelTitles:!t),gridData:(h:8,i:cd82e6af-63e7-4c5e-b833-f2c6115f7e2c,w:6,x:35,y:17),panelIndex:cd82e6af-63e7-4c5e-b833-f2c6115f7e2c,type:lens,version:'8.5.1'),(embeddableConfig:(attributes:(references:!((id:ead7bf06-990a-4b13-80d6-f3099a899ac8,name:indexpattern-datasource-layer-c3a79e05-6e54-44df-989b-a1955c4d3654,type:index-pattern),(id:ead7bf06-990a-4b13-80d6-f3099a899ac8,name:'7f76e321-8413-4d43-aa63-0b26655045da',type:index-pattern),(id:ead7bf06-990a-4b13-80d6-f3099a899ac8,name:'7757582d-f787-44c1-b88b-9c0cbad21bb6',type:index-pattern),(id:ead7bf06-990a-4b13-80d6-f3099a899ac8,name:'22142a53-d77d-4d82-8f99-655a2d8af5a0',type:index-pattern)),state:(adHocDataViews:(),datasourceStates:(indexpattern:(layers:(c3a79e05-6e54-44df-989b-a1955c4d3654:(columnOrder:!(a7e057cf-c79d-40ec-974e-43c2265618f6,'5db4bb6a-a4ee-49ef-987d-cc8431af284d'),columns:('5db4bb6a-a4ee-49ef-987d-cc8431af284d':(customLabel:!t,dataType:number,isBucketed:!f,label:Scans,operationType:count,params:(emptyAsNull:!t),scale:ratio,sourceField:___records___),a7e057cf-c79d-40ec-974e-43c2265618f6:(customLabel:!t,dataType:string,isBucketed:!t,label:Product,operationType:terms,params:(missingBucket:!f,orderBy:(columnId:'5db4bb6a-a4ee-49ef-987d-cc8431af284d',type:column),orderDirection:desc,otherBucket:!f,parentFormat:(id:terms),size:10),scale:ordinal,sourceField:fields.LogActionContextValue.keyword)),incompleteColumns:())))),filters:!(('$state':(store:appState),meta:(alias:!n,disabled:!f,index:'7f76e321-8413-4d43-aa63-0b26655045da',key:fields.LogAction.keyword,negate:!f,params:(query:Scan),type:phrase),query:(match_phrase:(fields.LogAction.keyword:Scan))),('$state':(store:appState),meta:(alias:!n,disabled:!f,index:'7757582d-f787-44c1-b88b-9c0cbad21bb6',key:fields.UserInfo.RetailerLocationCity.keyword,negate:!f,type:exists,value:exists),query:(exists:(field:fields.UserInfo.RetailerLocationCity.keyword))),('$state':(store:appState),meta:(alias:!n,disabled:!f,index:'22142a53-d77d-4d82-8f99-655a2d8af5a0',key:fields.UserInfo.RetailerName.keyword,negate:!t,params:!('Demo%20-%20Retailer','Not%20Listed'),type:phrases,value:!('Demo%20-%20Retailer','Not%20Listed')),query:(bool:(minimum_should_match:1,should:!((match_phrase:(fields.UserInfo.RetailerName.keyword:'Demo%20-%20Retailer')),(match_phrase:(fields.UserInfo.RetailerName.keyword:'Not%20Listed'))))))),internalReferences:!(),query:(language:kuery,query:''),visualization:(columns:!((columnId:a7e057cf-c79d-40ec-974e-43c2265618f6,width:376),(columnId:'5db4bb6a-a4ee-49ef-987d-cc8431af284d')),layerId:c3a79e05-6e54-44df-989b-a1955c4d3654,layerType:data)),title:'',type:lens,visualizationType:lnsDatatable),enhancements:(),hidePanelTitles:!f),gridData:(h:9,i:a0225c92-b080-42ba-9d54-a1ae6a9cf6c9,w:23,x:0,y:25),panelIndex:a0225c92-b080-42ba-9d54-a1ae6a9cf6c9,title:'Top%20Products%20Scanned',type:lens,version:'8.5.1'),(embeddableConfig:(attributes:(references:!((id:ead7bf06-990a-4b13-80d6-f3099a899ac8,name:indexpattern-datasource-layer-1dc4bcfb-62b5-4f71-8839-9f1cc7baccbf,type:index-pattern),(id:ead7bf06-990a-4b13-80d6-f3099a899ac8,name:'03301d76-ae86-44b7-8ab9-e579f8081dfb',type:index-pattern),(id:ead7bf06-990a-4b13-80d6-f3099a899ac8,name:fdf0984f-9338-4e75-80a3-40eb54a862fe,type:index-pattern)),state:(adHocDataViews:(),datasourceStates:(indexpattern:(layers:('1dc4bcfb-62b5-4f71-8839-9f1cc7baccbf':(columnOrder:!('0c1cdb77-c06b-4137-899a-dd0566ee19d2'),columns:('0c1cdb77-c06b-4137-899a-dd0566ee19d2':(customLabel:!t,dataType:number,filter:(language:kuery,query:''),isBucketed:!f,label:Users,operationType:unique_count,params:(emptyAsNull:!t),scale:ratio,sourceField:fields.UserInfo.Email.keyword)),incompleteColumns:())))),filters:!(('$state':(store:appState),meta:(alias:!n,disabled:!f,index:'03301d76-ae86-44b7-8ab9-e579f8081dfb',key:fields.UserInfo.RetailerLocationCity.keyword,negate:!f,type:exists,value:exists),query:(exists:(field:fields.UserInfo.RetailerLocationCity.keyword))),('$state':(store:appState),meta:(alias:!n,disabled:!f,index:fdf0984f-9338-4e75-80a3-40eb54a862fe,key:fields.UserInfo.RetailerName.keyword,negate:!t,params:!('Demo%20-%20Retailer','Not%20Listed'),type:phrases,value:!('Demo%20-%20Retailer','Not%20Listed')),query:(bool:(minimum_should_match:1,should:!((match_phrase:(fields.UserInfo.RetailerName.keyword:'Demo%20-%20Retailer')),(match_phrase:(fields.UserInfo.RetailerName.keyword:'Not%20Listed'))))))),internalReferences:!(),query:(language:lucene,query:''),visualization:(accessor:'0c1cdb77-c06b-4137-899a-dd0566ee19d2',colorMode:Background,layerId:'1dc4bcfb-62b5-4f71-8839-9f1cc7baccbf',layerType:data,palette:(name:custom,params:(colorStops:!((color:%23ff4f40cc,stop:!n)),continuity:all,maxSteps:5,name:custom,progression:fixed,rangeMax:!n,rangeMin:!n,rangeType:number,reverse:!f,steps:3,stops:!((color:%23ff4f40cc,stop:1264))),type:palette))),title:'',type:lens,visualizationType:lnsLegacyMetric),enhancements:(),hidePanelTitles:!t),gridData:(h:8,i:'3aacf022-60f0-458e-9560-8322e81873a4',w:7,x:41,y:17),panelIndex:'3aacf022-60f0-458e-9560-8322e81873a4',title:'Users%20that%20can%20view%20your%20brand',type:lens,version:'8.5.1'),(embeddableConfig:(attributes:(references:!((id:ead7bf06-990a-4b13-80d6-f3099a899ac8,name:indexpattern-datasource-layer-1ac1a6a7-3fb8-41e3-9d10-72e1747c51f1,type:index-pattern),(id:ead7bf06-990a-4b13-80d6-f3099a899ac8,name:'3dc6f176-ffb1-4cfe-9a3f-24a726bfe6e7',type:index-pattern),(id:ead7bf06-990a-4b13-80d6-f3099a899ac8,name:dddebbfa-e599-4a68-94cd-f25a7871e377,type:index-pattern),(id:ead7bf06-990a-4b13-80d6-f3099a899ac8,name:dc8cba8b-436f-4614-99cb-3e497c686db7,type:index-pattern),(id:ead7bf06-990a-4b13-80d6-f3099a899ac8,name:'0c7404cb-b012-4fdd-9a63-7e8987de15a7',type:index-pattern)),state:(adHocDataViews:(),datasourceStates:(indexpattern:(layers:('1ac1a6a7-3fb8-41e3-9d10-72e1747c51f1':(columnOrder:!('551f78e8-73ed-4d06-9281-eefaa84109f9',cc136923-66f1-4c72-a19c-eb19ba1d4b03),columns:('551f78e8-73ed-4d06-9281-eefaa84109f9':(customLabel:!t,dataType:string,isBucketed:!t,label:Product,operationType:terms,params:(missingBucket:!f,orderBy:(columnId:cc136923-66f1-4c72-a19c-eb19ba1d4b03,type:column),orderDirection:desc,otherBucket:!f,parentFormat:(id:terms),secondaryFields:!(),size:10),scale:ordinal,sourceField:fields.ClientLog.name.keyword),cc136923-66f1-4c72-a19c-eb19ba1d4b03:(customLabel:!t,dataType:number,isBucketed:!f,label:Searches,operationType:count,params:(emptyAsNull:!t),scale:ratio,sourceField:___records___)),incompleteColumns:())))),filters:!(('$state':(store:appState),meta:(alias:!n,disabled:!f,index:'3dc6f176-ffb1-4cfe-9a3f-24a726bfe6e7',key:fields.ClientLog.context.keyword,negate:!f,params:(query:searchSelection),type:phrase),query:(match_phrase:(fields.ClientLog.context.keyword:searchSelection))),('$state':(store:appState),meta:(alias:!n,disabled:!f,index:dddebbfa-e599-4a68-94cd-f25a7871e377,key:fields.UserInfo.RetailerLocationCity.keyword,negate:!f,type:exists,value:exists),query:(exists:(field:fields.UserInfo.RetailerLocationCity.keyword))),('$state':(store:appState),meta:(alias:!n,disabled:!f,index:dc8cba8b-436f-4614-99cb-3e497c686db7,key:fields.UserInfo.RetailerName.keyword,negate:!t,params:!('Demo%20-%20Retailer','Not%20Listed'),type:phrases,value:!('Demo%20-%20Retailer','Not%20Listed')),query:(bool:(minimum_should_match:1,should:!((match_phrase:(fields.UserInfo.RetailerName.keyword:'Demo%20-%20Retailer')),(match_phrase:(fields.UserInfo.RetailerName.keyword:'Not%20Listed')))))),('$state':(store:appState),meta:(alias:!n,disabled:!f,index:'0c7404cb-b012-4fdd-9a63-7e8987de15a7',key:fields.ClientLog.type.keyword,negate:!f,params:(query:product),type:phrase),query:(match_phrase:(fields.ClientLog.type.keyword:product)))),internalReferences:!(),query:(language:kuery,query:''),visualization:(columns:!((columnId:cc136923-66f1-4c72-a19c-eb19ba1d4b03,isTransposed:!f),(columnId:'551f78e8-73ed-4d06-9281-eefaa84109f9',isTransposed:!f,width:349)),layerId:'1ac1a6a7-3fb8-41e3-9d10-72e1747c51f1',layerType:data)),title:'',type:lens,visualizationType:lnsDatatable),enhancements:(),hidePanelTitles:!f),gridData:(h:9,i:'7470155d-fa11-402c-9b1c-557b8763d5f6',w:25,x:23,y:25),panelIndex:'7470155d-fa11-402c-9b1c-557b8763d5f6',title:'Top%20Products%20Searched',type:lens,version:'8.5.1'),(embeddableConfig:(attributes:(references:!((id:ead7bf06-990a-4b13-80d6-f3099a899ac8,name:indexpattern-datasource-layer-1ac1a6a7-3fb8-41e3-9d10-72e1747c51f1,type:index-pattern),(id:ead7bf06-990a-4b13-80d6-f3099a899ac8,name:'9033d3b3-c8dd-44a8-9cd0-e9a1fa5545b1',type:index-pattern),(id:ead7bf06-990a-4b13-80d6-f3099a899ac8,name:'6cd6ee6d-bc31-4674-a62e-31d6171d993b',type:index-pattern),(id:ead7bf06-990a-4b13-80d6-f3099a899ac8,name:'2e67277b-de9b-4082-a4c5-c5659f16ef09',type:index-pattern)),state:(adHocDataViews:(),datasourceStates:(indexpattern:(layers:('1ac1a6a7-3fb8-41e3-9d10-72e1747c51f1':(columnOrder:!('1735acf2-57ff-40b9-85d9-e0ed14bef07f',cc136923-66f1-4c72-a19c-eb19ba1d4b03),columns:('1735acf2-57ff-40b9-85d9-e0ed14bef07f':(customLabel:!t,dataType:string,isBucketed:!t,label:Product,operationType:terms,params:(missingBucket:!f,orderBy:(columnId:cc136923-66f1-4c72-a19c-eb19ba1d4b03,type:column),orderDirection:desc,otherBucket:!f,parentFormat:(id:terms),size:10),scale:ordinal,sourceField:fields.ClientLog.productName.keyword),cc136923-66f1-4c72-a19c-eb19ba1d4b03:(customLabel:!t,dataType:number,isBucketed:!f,label:'Videos%20Watched',operationType:count,params:(emptyAsNull:!t),scale:ratio,sourceField:___records___)),incompleteColumns:())))),filters:!(('$state':(store:appState),meta:(alias:!n,disabled:!f,index:'9033d3b3-c8dd-44a8-9cd0-e9a1fa5545b1',key:fields.ClientLog.context.keyword,negate:!f,params:(query:productVideoWatched),type:phrase),query:(match_phrase:(fields.ClientLog.context.keyword:productVideoWatched))),('$state':(store:appState),meta:(alias:!n,disabled:!f,index:'6cd6ee6d-bc31-4674-a62e-31d6171d993b',key:fields.UserInfo.RetailerLocationCity.keyword,negate:!f,type:exists,value:exists),query:(exists:(field:fields.UserInfo.RetailerLocationCity.keyword))),('$state':(store:appState),meta:(alias:!n,disabled:!f,index:'2e67277b-de9b-4082-a4c5-c5659f16ef09',key:fields.UserInfo.RetailerName.keyword,negate:!t,params:!('Demo%20-%20Retailer','Not%20Listed'),type:phrases,value:!('Demo%20-%20Retailer','Not%20Listed')),query:(bool:(minimum_should_match:1,should:!((match_phrase:(fields.UserInfo.RetailerName.keyword:'Demo%20-%20Retailer')),(match_phrase:(fields.UserInfo.RetailerName.keyword:'Not%20Listed'))))))),internalReferences:!(),query:(language:kuery,query:''),visualization:(columns:!((columnId:cc136923-66f1-4c72-a19c-eb19ba1d4b03,isTransposed:!f),(columnId:'1735acf2-57ff-40b9-85d9-e0ed14bef07f',isTransposed:!f,width:348)),layerId:'1ac1a6a7-3fb8-41e3-9d10-72e1747c51f1',layerType:data)),title:'',type:lens,visualizationType:lnsDatatable),enhancements:(),hidePanelTitles:!f),gridData:(h:9,i:'3a955c7e-9e3d-4f1d-b4ab-1dbdedfc5c19',w:23,x:0,y:34),panelIndex:'3a955c7e-9e3d-4f1d-b4ab-1dbdedfc5c19',title:'Top%20Videos%20Watched',type:lens,version:'8.5.1'),(embeddableConfig:(attributes:(references:!((id:ead7bf06-990a-4b13-80d6-f3099a899ac8,name:indexpattern-datasource-layer-ae9d07c8-f881-4e7c-9ada-f0d93246a4de,type:index-pattern),(id:ead7bf06-990a-4b13-80d6-f3099a899ac8,name:d8e7c882-5bbd-457c-b98a-a27c170759c8,type:index-pattern),(id:ead7bf06-990a-4b13-80d6-f3099a899ac8,name:'0364c0bc-914c-4dbb-9c87-460e01ab4f5d',type:index-pattern),(id:ead7bf06-990a-4b13-80d6-f3099a899ac8,name:'5ed5a3fa-6977-490e-aaaa-96b5022e44bd',type:index-pattern),(id:ead7bf06-990a-4b13-80d6-f3099a899ac8,name:'4365f02b-d0af-4774-8ab4-6a7de086bc96',type:index-pattern)),state:(adHocDataViews:(),datasourceStates:(indexpattern:(layers:(ae9d07c8-f881-4e7c-9ada-f0d93246a4de:(columnOrder:!('3bd8c87f-da98-4a5d-9f0c-1bc6fe62fe02','9f1fa0f1-220d-4de8-9efd-7e2752a09d3b'),columns:('3bd8c87f-da98-4a5d-9f0c-1bc6fe62fe02':(customLabel:!t,dataType:string,isBucketed:!t,label:Product,operationType:terms,params:(missingBucket:!f,orderBy:(columnId:'9f1fa0f1-220d-4de8-9efd-7e2752a09d3b',type:column),orderDirection:desc,otherBucket:!f,parentFormat:(id:terms),size:10),scale:ordinal,sourceField:fields.LogActionContextValue.keyword),'9f1fa0f1-220d-4de8-9efd-7e2752a09d3b':(customLabel:!t,dataType:number,isBucketed:!f,label:Count,operationType:count,params:(emptyAsNull:!t),scale:ratio,sourceField:___records___)),incompleteColumns:())))),filters:!(('$state':(store:appState),meta:(alias:!n,disabled:!f,index:d8e7c882-5bbd-457c-b98a-a27c170759c8,key:fields.LogAction.keyword,negate:!f,params:(query:View),type:phrase),query:(match_phrase:(fields.LogAction.keyword:View))),('$state':(store:appState),meta:(alias:!n,disabled:!f,index:'0364c0bc-914c-4dbb-9c87-460e01ab4f5d',key:fields.LogActionContext.keyword,negate:!f,params:(query:Product),type:phrase),query:(match_phrase:(fields.LogActionContext.keyword:Product))),('$state':(store:appState),meta:(alias:!n,disabled:!f,index:'5ed5a3fa-6977-490e-aaaa-96b5022e44bd',key:fields.UserInfo.RetailerLocationCity.keyword,negate:!f,type:exists,value:exists),query:(exists:(field:fields.UserInfo.RetailerLocationCity.keyword))),('$state':(store:appState),meta:(alias:!n,disabled:!f,index:'4365f02b-d0af-4774-8ab4-6a7de086bc96',key:fields.UserInfo.RetailerName.keyword,negate:!t,params:!('Demo%20-%20Retailer','Not%20Listed'),type:phrases,value:!('Demo%20-%20Retailer','Not%20Listed')),query:(bool:(minimum_should_match:1,should:!((match_phrase:(fields.UserInfo.RetailerName.keyword:'Demo%20-%20Retailer')),(match_phrase:(fields.UserInfo.RetailerName.keyword:'Not%20Listed'))))))),internalReferences:!(),query:(language:kuery,query:''),visualization:(columns:!((columnId:'3bd8c87f-da98-4a5d-9f0c-1bc6fe62fe02',isTransposed:!f,width:403),(columnId:'9f1fa0f1-220d-4de8-9efd-7e2752a09d3b',isTransposed:!f)),layerId:ae9d07c8-f881-4e7c-9ada-f0d93246a4de,layerType:data)),title:'',type:lens,visualizationType:lnsDatatable),enhancements:(),hidePanelTitles:!f),gridData:(h:9,i:f14af5a2-8dd6-4a5b-8ed9-c54d7378ba20,w:25,x:23,y:34),panelIndex:f14af5a2-8dd6-4a5b-8ed9-c54d7378ba20,title:'Top%20Products%20Viewed',type:lens,version:'8.5.1'),(embeddableConfig:(attributes:(description:'',layerListJSON:'%5B%7B%22locale%22:%22autoselect%22,%22sourceDescriptor%22:%7B%22type%22:%22EMS_TMS%22,%22isAutoSelect%22:false,%22lightModeDefault%22:%22road_map_desaturated%22,%22id%22:%22road_map%22%7D,%22id%22:%2252ad22f3-68e4-48d8-b82b-ecef35c9be68%22,%22label%22:null,%22minZoom%22:0,%22maxZoom%22:24,%22alpha%22:1,%22visible%22:true,%22style%22:%7B%22type%22:%22EMS_VECTOR_TILE%22,%22color%22:%22%22%7D,%22includeInFitToBounds%22:true,%22type%22:%22EMS_VECTOR_TILE%22%7D,%7B%22joins%22:%5B%7B%22leftField%22:%22postal%22,%22right%22:%7B%22type%22:%22ES_TERM_SOURCE%22,%22id%22:%22417e2dc6-3442-46ae-9222-5beadbfe66ea%22,%22term%22:%22fields.UserInfo.RetailerLocationState.keyword%22,%22metrics%22:%5B%7B%22type%22:%22count%22%7D%5D,%22applyGlobalQuery%22:true,%22applyGlobalTime%22:true,%22applyForceRefresh%22:true,%22whereQuery%22:%7B%22query%22:%22fields.UserInfo.RetailerLocationState.keyword:*%22,%22language%22:%22lucene%22%7D,%22indexPatternId%22:%22ead7bf06-990a-4b13-80d6-f3099a899ac8%22%7D%7D%5D,%22sourceDescriptor%22:%7B%22type%22:%22EMS_FILE%22,%22id%22:%22usa_states%22,%22tooltipProperties%22:%5B%22postal%22%5D%7D,%22style%22:%7B%22type%22:%22VECTOR%22,%22properties%22:%7B%22icon%22:%7B%22type%22:%22STATIC%22,%22options%22:%7B%22value%22:%22marker%22%7D%7D,%22fillColor%22:%7B%22type%22:%22DYNAMIC%22,%22options%22:%7B%22color%22:%22theclassic%22,%22colorCategory%22:%22palette_0%22,%22field%22:%7B%22name%22:%22__kbnjoin__count__417e2dc6-3442-46ae-9222-5beadbfe66ea%22,%22origin%22:%22join%22%7D,%22fieldMetaOptions%22:%7B%22isEnabled%22:true,%22sigma%22:3%7D,%22type%22:%22ORDINAL%22,%22useCustomColorRamp%22:false%7D%7D,%22lineColor%22:%7B%22type%22:%22STATIC%22,%22options%22:%7B%22color%22:%22%233d3d3d%22%7D%7D,%22lineWidth%22:%7B%22type%22:%22STATIC%22,%22options%22:%7B%22size%22:1%7D%7D,%22iconSize%22:%7B%22type%22:%22STATIC%22,%22options%22:%7B%22size%22:6%7D%7D,%22iconOrientation%22:%7B%22type%22:%22STATIC%22,%22options%22:%7B%22orientation%22:0%7D%7D,%22labelText%22:%7B%22type%22:%22DYNAMIC%22,%22options%22:%7B%22field%22:%7B%22name%22:%22__kbnjoin__count__417e2dc6-3442-46ae-9222-5beadbfe66ea%22,%22origin%22:%22join%22%7D%7D%7D,%22labelColor%22:%7B%22type%22:%22STATIC%22,%22options%22:%7B%22color%22:%22%23FFF%22%7D%7D,%22labelSize%22:%7B%22type%22:%22STATIC%22,%22options%22:%7B%22size%22:24%7D%7D,%22labelZoomRange%22:%7B%22options%22:%7B%22useLayerZoomRange%22:true,%22minZoom%22:0,%22maxZoom%22:24%7D%7D,%22labelBorderColor%22:%7B%22type%22:%22DYNAMIC%22,%22options%22:%7B%22color%22:%22theclassic%22,%22colorCategory%22:%22palette_0%22,%22field%22:%7B%22name%22:%22__kbnjoin__count__417e2dc6-3442-46ae-9222-5beadbfe66ea%22,%22origin%22:%22join%22%7D,%22fieldMetaOptions%22:%7B%22isEnabled%22:true,%22sigma%22:3%7D,%22type%22:%22ORDINAL%22,%22useCustomColorRamp%22:false%7D%7D,%22symbolizeAs%22:%7B%22options%22:%7B%22value%22:%22circle%22%7D%7D,%22labelBorderSize%22:%7B%22options%22:%7B%22size%22:%22SMALL%22%7D%7D%7D,%22isTimeAware%22:true%7D,%22id%22:%229806fcc9-9f7d-4eaf-a1dd-b0b2b5560398%22,%22label%22:%22BF%20Usage%20By%20State%22,%22minZoom%22:0,%22maxZoom%22:24,%22alpha%22:0.25,%22visible%22:true,%22includeInFitToBounds%22:true,%22type%22:%22GEOJSON_VECTOR%22,%22disableTooltips%22:false%7D,%7B%22joins%22:%5B%7B%22leftField%22:%22zip%22,%22right%22:%7B%22type%22:%22ES_TERM_SOURCE%22,%22id%22:%2226e2a8b7-5c1a-46c9-bbbe-7ad8756f2645%22,%22term%22:%22fields.UserInfo.RetailerLocationPostalCode.keyword%22,%22metrics%22:%5B%7B%22type%22:%22count%22%7D%5D,%22applyGlobalQuery%22:true,%22applyGlobalTime%22:true,%22applyForceRefresh%22:true,%22indexPatternId%22:%22ead7bf06-990a-4b13-80d6-f3099a899ac8%22%7D%7D%5D,%22sourceDescriptor%22:%7B%22type%22:%22EMS_FILE%22,%22id%22:%22usa_zip_codes%22,%22tooltipProperties%22:%5B%22zip%22%5D%7D,%22style%22:%7B%22type%22:%22VECTOR%22,%22properties%22:%7B%22icon%22:%7B%22type%22:%22STATIC%22,%22options%22:%7B%22value%22:%22marker%22%7D%7D,%22fillColor%22:%7B%22type%22:%22DYNAMIC%22,%22options%22:%7B%22color%22:%22theclassic%22,%22colorCategory%22:%22palette_0%22,%22field%22:%7B%22name%22:%22__kbnjoin__count__26e2a8b7-5c1a-46c9-bbbe-7ad8756f2645%22,%22origin%22:%22join%22%7D,%22fieldMetaOptions%22:%7B%22isEnabled%22:true,%22sigma%22:3%7D,%22type%22:%22ORDINAL%22,%22useCustomColorRamp%22:false%7D%7D,%22lineColor%22:%7B%22type%22:%22DYNAMIC%22,%22options%22:%7B%22color%22:%22theclassic%22,%22colorCategory%22:%22palette_0%22,%22field%22:%7B%22name%22:%22__kbnjoin__count__26e2a8b7-5c1a-46c9-bbbe-7ad8756f2645%22,%22origin%22:%22join%22%7D,%22fieldMetaOptions%22:%7B%22isEnabled%22:true,%22sigma%22:3%7D,%22type%22:%22ORDINAL%22,%22useCustomColorRamp%22:false%7D%7D,%22lineWidth%22:%7B%22type%22:%22STATIC%22,%22options%22:%7B%22size%22:1%7D%7D,%22iconSize%22:%7B%22type%22:%22STATIC%22,%22options%22:%7B%22size%22:6%7D%7D,%22iconOrientation%22:%7B%22type%22:%22STATIC%22,%22options%22:%7B%22orientation%22:0%7D%7D,%22labelText%22:%7B%22type%22:%22DYNAMIC%22,%22options%22:%7B%22field%22:%7B%22name%22:%22__kbnjoin__count__26e2a8b7-5c1a-46c9-bbbe-7ad8756f2645%22,%22origin%22:%22join%22%7D%7D%7D,%22labelColor%22:%7B%22type%22:%22STATIC%22,%22options%22:%7B%22color%22:%22%23FFF%22%7D%7D,%22labelSize%22:%7B%22type%22:%22STATIC%22,%22options%22:%7B%22size%22:10%7D%7D,%22labelZoomRange%22:%7B%22options%22:%7B%22useLayerZoomRange%22:true,%22minZoom%22:0,%22maxZoom%22:24%7D%7D,%22labelBorderColor%22:%7B%22type%22:%22STATIC%22,%22options%22:%7B%22color%22:%22%23FFF%22%7D%7D,%22symbolizeAs%22:%7B%22options%22:%7B%22value%22:%22circle%22%7D%7D,%22labelBorderSize%22:%7B%22options%22:%7B%22size%22:%22NONE%22%7D%7D%7D,%22isTimeAware%22:true%7D,%22id%22:%22c05b6d13-1421-43ff-a852-b4b07848ac7b%22,%22label%22:%22BF%20Usage%20By%20Zip%20Code%22,%22minZoom%22:0,%22maxZoom%22:24,%22alpha%22:0.75,%22visible%22:true,%22includeInFitToBounds%22:true,%22type%22:%22GEOJSON_VECTOR%22,%22disableTooltips%22:false%7D%5D',mapStateJSON:'%7B%22adHocDataViews%22:%5B%5D,%22zoom%22:3.25,%22center%22:%7B%22lon%22:-95.85959,%22lat%22:38.41532%7D,%22timeFilters%22:%7B%22from%22:%22now-30d%2Fd%22,%22to%22:%22now%22%7D,%22refreshConfig%22:%7B%22isPaused%22:true,%22interval%22:0%7D,%22query%22:%7B%22query%22:%22%22,%22language%22:%22kuery%22%7D,%22filters%22:%5B%7B%22meta%22:%7B%22index%22:%22ead7bf06-990a-4b13-80d6-f3099a899ac8%22,%22alias%22:null,%22negate%22:true,%22disabled%22:false,%22type%22:%22phrase%22,%22key%22:%22fields.UserInfo.RetailerLocationStoreName%22,%22params%22:%7B%22query%22:%22Landing%20International%22%7D%7D,%22query%22:%7B%22match_phrase%22:%7B%22fields.UserInfo.RetailerLocationStoreName%22:%22Landing%20International%22%7D%7D,%22$state%22:%7B%22store%22:%22appState%22%7D%7D,%7B%22meta%22:%7B%22index%22:%22ead7bf06-990a-4b13-80d6-f3099a899ac8%22,%22alias%22:null,%22negate%22:false,%22disabled%22:false,%22type%22:%22phrase%22,%22key%22:%22fields.LogAction.keyword%22,%22params%22:%7B%22query%22:%22View%22%7D%7D,%22query%22:%7B%22match_phrase%22:%7B%22fields.LogAction.keyword%22:%22View%22%7D%7D,%22$state%22:%7B%22store%22:%22appState%22%7D%7D,%7B%22meta%22:%7B%22index%22:%22ead7bf06-990a-4b13-80d6-f3099a899ac8%22,%22alias%22:null,%22negate%22:false,%22disabled%22:false,%22type%22:%22exists%22,%22key%22:%22fields.UserInfo.RetailerLocationCity.keyword%22,%22value%22:%22exists%22%7D,%22query%22:%7B%22exists%22:%7B%22field%22:%22fields.UserInfo.RetailerLocationCity.keyword%22%7D%7D,%22$state%22:%7B%22store%22:%22appState%22%7D%7D,%7B%22meta%22:%7B%22index%22:%22ead7bf06-990a-4b13-80d6-f3099a899ac8%22,%22type%22:%22phrases%22,%22key%22:%22fields.UserInfo.RetailerName.keyword%22,%22params%22:%5B%22Demo%20-%20Retailer%22,%22Not%20Listed%22%5D,%22alias%22:null,%22negate%22:true,%22disabled%22:false,%22value%22:%5B%22Demo%20-%20Retailer%22,%22Not%20Listed%22%5D%7D,%22query%22:%7B%22bool%22:%7B%22should%22:%5B%7B%22match_phrase%22:%7B%22fields.UserInfo.RetailerName.keyword%22:%22Demo%20-%20Retailer%22%7D%7D,%7B%22match_phrase%22:%7B%22fields.UserInfo.RetailerName.keyword%22:%22Not%20Listed%22%7D%7D%5D,%22minimum_should_match%22:1%7D%7D,%22$state%22:%7B%22store%22:%22appState%22%7D%7D%5D,%22settings%22:%7B%22autoFitToDataBounds%22:true,%22backgroundColor%22:%22%231d1e24%22,%22customIcons%22:%5B%5D,%22disableInteractive%22:false,%22disableTooltipControl%22:false,%22hideToolbarOverlay%22:false,%22hideLayerControl%22:false,%22hideViewControl%22:false,%22initialLocation%22:%22AUTO_FIT_TO_BOUNDS%22,%22fixedLocation%22:%7B%22lat%22:0,%22lon%22:0,%22zoom%22:2%7D,%22browserLocation%22:%7B%22zoom%22:2%7D,%22keydownScrollZoom%22:false,%22maxZoom%22:24,%22minZoom%22:0,%22showScaleControl%22:false,%22showSpatialFilters%22:true,%22showTimesliderToggleButton%22:true,%22spatialFiltersAlpa%22:0.3,%22spatialFiltersFillColor%22:%22%23DA8B45%22,%22spatialFiltersLineColor%22:%22%23DA8B45%22%7D%7D',title:'',uiStateJSON:'%7B%22isLayerTOCOpen%22:true,%22openTOCDetails%22:%5B%22c05b6d13-1421-43ff-a852-b4b07848ac7b%22,%229806fcc9-9f7d-4eaf-a1dd-b0b2b5560398%22%5D%7D'),enhancements:(),hiddenLayers:!(),isLayerTOCOpen:!f,mapBuffer:(maxLat:66.51326,maxLon:-45,minLat:0,minLon:-180),mapCenter:(lat:38.41532,lon:-98.32583,zoom:2.7),openTOCDetails:!(c05b6d13-1421-43ff-a852-b4b07848ac7b,'9806fcc9-9f7d-4eaf-a1dd-b0b2b5560398')),gridData:(h:15,i:'453475fc-fbdb-4253-af82-6798eb621812',w:24,x:0,y:43),panelIndex:'453475fc-fbdb-4253-af82-6798eb621812',title:'Map%20-%20App%20Usage%20By%20Zip%20Code',type:map,version:'8.5.1'),(embeddableConfig:(attributes:(references:!((id:ead7bf06-990a-4b13-80d6-f3099a899ac8,name:indexpattern-datasource-layer-366ee998-9c2b-4484-8ec3-3fb25d92ae8e,type:index-pattern),(id:ead7bf06-990a-4b13-80d6-f3099a899ac8,name:'86d85bed-75ae-4fb1-8381-9ee152f9e706',type:index-pattern),(id:ead7bf06-990a-4b13-80d6-f3099a899ac8,name:d30feb70-fc18-4612-b0f2-4648bd84ff08,type:index-pattern),(id:ead7bf06-990a-4b13-80d6-f3099a899ac8,name:dd2e2ffe-ee73-4e63-9cd2-b4c55ab2287d,type:index-pattern)),state:(adHocDataViews:(),datasourceStates:(indexpattern:(layers:('366ee998-9c2b-4484-8ec3-3fb25d92ae8e':(columnOrder:!(de6c5a1e-8711-482e-b71a-c5a1a676dbd0,ce0da2ea-fd40-4f9c-ba41-48c6d0de0efc,e46f59f6-da4d-4cfe-8335-76707399665e,'1e2a60f4-eff0-4ab6-b5cc-91a16f899096','4e0b111d-a7aa-49c2-ba51-48a852105618'),columns:('1e2a60f4-eff0-4ab6-b5cc-91a16f899096':(customLabel:!t,dataType:string,isBucketed:!t,label:State,operationType:terms,params:(missingBucket:!f,orderBy:(columnId:'4e0b111d-a7aa-49c2-ba51-48a852105618',type:column),orderDirection:desc,otherBucket:!t,parentFormat:(id:terms),size:10000),scale:ordinal,sourceField:fields.UserInfo.RetailerLocationState.keyword),'4e0b111d-a7aa-49c2-ba51-48a852105618':(customLabel:!t,dataType:number,isBucketed:!f,label:'Activity%20%23',operationType:count,params:(emptyAsNull:!t),scale:ratio,sourceField:___records___),ce0da2ea-fd40-4f9c-ba41-48c6d0de0efc:(customLabel:!t,dataType:string,isBucketed:!t,label:'Store%20Number',operationType:terms,params:(exclude:!(0),excludeIsRegex:!f,missingBucket:!f,orderBy:(columnId:'4e0b111d-a7aa-49c2-ba51-48a852105618',type:column),orderDirection:desc,otherBucket:!f,parentFormat:(id:terms),secondaryFields:!(),size:10),scale:ordinal,sourceField:fields.UserInfo.RetailerLocationStoreNumber.text),de6c5a1e-8711-482e-b71a-c5a1a676dbd0:(customLabel:!t,dataType:string,isBucketed:!t,label:'Retailer%20Name',operationType:terms,params:(missingBucket:!f,orderBy:(columnId:'4e0b111d-a7aa-49c2-ba51-48a852105618',type:column),orderDirection:desc,otherBucket:!t,parentFormat:(id:terms),size:10000),scale:ordinal,sourceField:fields.UserInfo.RetailerName.keyword),e46f59f6-da4d-4cfe-8335-76707399665e:(customLabel:!t,dataType:string,isBucketed:!t,label:Location,operationType:terms,params:(exclude:!(0),excludeIsRegex:!f,missingBucket:!f,orderBy:(columnId:'4e0b111d-a7aa-49c2-ba51-48a852105618',type:column),orderDirection:desc,otherBucket:!f,parentFormat:(id:terms),size:10),scale:ordinal,sourceField:fields.UserInfo.RetailerLocationCity.keyword)),incompleteColumns:())))),filters:!(('$state':(store:appState),meta:(alias:!n,disabled:!f,index:'86d85bed-75ae-4fb1-8381-9ee152f9e706',key:fields.LogAction.keyword,negate:!f,params:(query:View),type:phrase),query:(match_phrase:(fields.LogAction.keyword:View))),('$state':(store:appState),meta:(alias:!n,disabled:!f,index:d30feb70-fc18-4612-b0f2-4648bd84ff08,key:fields.UserInfo.RetailerLocationCity.keyword,negate:!f,type:exists,value:exists),query:(exists:(field:fields.UserInfo.RetailerLocationCity.keyword))),('$state':(store:appState),meta:(alias:!n,disabled:!f,index:dd2e2ffe-ee73-4e63-9cd2-b4c55ab2287d,key:fields.UserInfo.RetailerName.keyword,negate:!t,params:!('Demo%20-%20Retailer','Not%20Listed'),type:phrases,value:!('Demo%20-%20Retailer','Not%20Listed')),query:(bool:(minimum_should_match:1,should:!((match_phrase:(fields.UserInfo.RetailerName.keyword:'Demo%20-%20Retailer')),(match_phrase:(fields.UserInfo.RetailerName.keyword:'Not%20Listed'))))))),internalReferences:!(),query:(language:lucene,query:''),visualization:(columns:!((columnId:e46f59f6-da4d-4cfe-8335-76707399665e,isTransposed:!f),(columnId:ce0da2ea-fd40-4f9c-ba41-48c6d0de0efc,isTransposed:!f),(columnId:'4e0b111d-a7aa-49c2-ba51-48a852105618',isTransposed:!f),(columnId:de6c5a1e-8711-482e-b71a-c5a1a676dbd0,isTransposed:!f),(columnId:'1e2a60f4-eff0-4ab6-b5cc-91a16f899096',isTransposed:!f,width:78.6)),layerId:'366ee998-9c2b-4484-8ec3-3fb25d92ae8e',layerType:data,sorting:(columnId:'4e0b111d-a7aa-49c2-ba51-48a852105618',direction:desc))),title:'',type:lens,visualizationType:lnsDatatable),enhancements:(),hidePanelTitles:!f),gridData:(h:15,i:'29033c80-0ee0-4245-aba3-b7e5fb07175c',w:24,x:24,y:43),panelIndex:'29033c80-0ee0-4245-aba3-b7e5fb07175c',title:'Top%20Locations%20by%20Activity',type:lens,version:'8.5.1'),(embeddableConfig:(enhancements:()),gridData:(h:14,i:'52386fad-ba32-428c-8256-e4b07b8d4633',w:48,x:0,y:58),id:'8b9170f0-ea3e-11ed-86a2-7979a688a9f4',panelIndex:'52386fad-ba32-428c-8256-e4b07b8d4633',type:visualization,version:'8.5.1')),query:(language:kuery,query:'fields.ClientLog.brandName.keyword:%22${brandName}%22%20OR%20fields.LogActionContextInfo.Brand.keyword:%22${brandName}%22%20OR%20(fields.ClientLog.context.keyword:%22searchSelection%22%20AND%20fields.ClientLog.type.keyword:%22brand%22%20AND%20fields.ClientLog.name.keyword:%22${brandName}%22)%20OR%20(fields.LogActionContext.keyword:%22Brand%22%20AND%20fields.LogActionValue.keyword:%22${brandName}%22)%20OR%20(fields.ClientLog.brand.keyword:%22${brandName}%22)'),tags:!(),timeRange:(from:now-30d%2Fd,to:now),timeRestore:!t,title:'Brand%20Dashboard%20-%20Richard',viewMode:view)&show-time-filter=true"`;
    },
    /**
     * Share Link
     */
    shareToLink() {
      // this.$refs["shareLink"].openDialog(true)
      this.clipboard.once("success", () => {
        this.shareText = "Link Copied";
        this.$message.success("Copy success");
      });
      this.clipboard.once("error", (err) => {
        console.error(err);
      });
    },
    downloadQRCode() {
      // this.$refs["qrcodeView"].openDownloadQRdialo()
      // this.$router.push({
      //   name: "TrainingProductViewAll",
      //   query: {
      //     id: this.brand.id,
      //     name: this.brand.name
      //   }
      // })
      this.downloadText = "QR Dowloaded";
      const linkQr = `${window.location.origin}/training/${this.brand.shortName}`;
      downloadQR(linkQr, `${this.brand.name}_qrcode.png`);
    },
    handleCancel() {
      this.showVisible = false;
    },
    handleAddRetailerCancel() {
      this.showAddRetasilerVisible = false;
    },
    jumpToBrandProduct() {
      this.$router.push({
        name: "brandProduct",
        params: {
          id: this.contentLinkId,
        },
      });
    },
    openAddMoreCardDialog() {
      const hasCardInfo =
        this.brand.subscriptions && this.brand.subscriptions.length !== 0;
      this.$refs["cardListDialog"].openAddCardDialog(hasCardInfo);
    },
    openAddPaymentDialog() {
      this.$refs["addNewCardDialog"].openAddCardDialog();
    },
    async updateNewTrainingList() {
      if (this.$route.query.tab === "product") {
        await this.getProductList(this.userId);
        let noTrainingList = await this.getProducts(this.userId);
        noTrainingList = noTrainingList.map((item) => {
          item.activeText = "Edit";
          return item;
        });
        // this.tableDate = this.getTrainingProducts
        const haveTrainingList = this.formatProductTableList(
          this.getTrainingProducts
        );
        this.tableDate = haveTrainingList.concat(noTrainingList);
      } else {
        const brandId = this.brand.id ? this.brand.id : this.userId;
        this.tableDate = await this.getRetailersList(brandId);
        this.checkBrandHasGeneralRetailerOrNot();
      }
    },
    clickToEdit(value) {
      if (!value.training.isPublished && value.training.states === 0) {
        // setSesStorage("SAVE_DRAFT_ARR_LIST", [value])
        setSesStorage("EDIT_ONE_TRAINING_PRODUCT", [value]);
        if (this.$route.params.brandId) {
          this.$router.push({
            name: "adminBrandTrainingDetails",
            query: {
              isSaveDraft: false,
              id: value.id,
              draft: true,
            },
          });
        } else {
          this.$router.push({
            name: "BrandTrainingDetails",
            query: {
              isSaveDraft: false,
              id: value.id,
              draft: true,
            },
          });
        }
      } else {
        setSesStorage("EDIT_ONE_TRAINING_PRODUCT", [value]);
        if (this.$route.params.brandId) {
          this.$router.push({
            name: "adminBrandTrainingDetails",
            query: {
              isSaveDraft: false,
              id: value.id,
            },
          });
        } else {
          this.$router.push({
            name: "BrandTrainingDetails",
            query: {
              isSaveDraft: false,
              id: value.id,
            },
          });
        }
      }
    },
    async clickToDelete(value) {
      this.tableDate = this.tableDate.map((item) => {
        if (item.id === value.id) {
          item.isDetele = !item.isDetele;
        }
        return item;
      });
    },
    async sureDelete(value) {
      if (value.isSaveDraft) {
        let list = JSON.parse(getSesStorage("SAVE_DRAFT_ARR_LIST"));
        list = list.filter((item) => item.id !== value.id);
        setSesStorage("SAVE_DRAFT_ARR_LIST", list);
      } else {
        await trainingClient.deleteTrainingProduct(value.id);
        await this.clickToDelete(value);
      }
      await this.getProductList(this.userId);
      this.tableDate = this.getTrainingProducts;
    },
    editProduct(value) {
      setSesStorage("EDIT_ONE_TRAINING_PRODUCT", [value]);
      if (this.$route.params.brandId) {
        this.$router.push({
          name: "adminBrandTrainingDetails",
          params: {
            brandId: this.userId,
          },
          query: {
            isSaveDraft: false,
            id: value.id,
            draft: true,
          },
        }); 7
      } else {
        this.$router.push({
          name: "BrandTrainingDetails",
          query: {
            isSaveDraft: false,
            id: value.id,
            draft: true,
          },
        });
      }
    },
    async onChange(value, isDrag) {
      if (this.isUpdating) {
        return;
      }
      this.isUpdating = true;
      const param = {
        training: {
          demoTips: value.training.demoTips,
          isHero: value.training.hero,
          howToDemo: value.training.howToDemo,
          id: value.training.id,
          isPublished: true,
          states: value.public ? 2 : 1,
          sort: value.training.sort,
        },
        trainingBestUsedFors: value.trainingBestUsedFors,
        trainingVideos: value.trainingVideos,
        trainingCrossSellers: value.trainingCrossSellers,
        trainingSteps: value.trainingSteps,
      };
      if (isDrag) {
        param.training.states = value.training.states;
        param.training.isPublished = value.training.published;
      }
      //await trainingClient.updateTrainingProduct(value.id, param)
      await trainingClient
        .updateTrainingProductAndProTips(value.id, param)
        .finally(() => (this.isUpdating = false));
      // this.tableDate = this.getTrainingProducts
      // this.tableDate = this.getTrainingProducts.slice(
      //   (this.defaultPage - 1) * 17,
      //   this.defaultPage * 17
      // )
    },
    async clickToNewTab(value) {
      this.menuTab = value;
      this.isShowPlanStep = false;
      if (value === "product") {
        await this.getProductList(this.userId);
        let noTrainingList = await this.getProducts(this.userId);
        noTrainingList = noTrainingList.map((item) => {
          item.activeText = "Edit";
          return item;
        });
        // this.tableDate = this.getTrainingProducts
        const haveTrainingList = this.formatProductTableList(
          this.getTrainingProducts
        );
        this.tableDate = haveTrainingList.concat(noTrainingList);
      } else {
        this.tableDate = await this.getRetailersList(this.brand.id);
        this.checkBrandHasGeneralRetailerOrNot();
      }
      this.downloadText = "Download QR code";
      this.shareText = "Share Link";
      if (this.$route.params.brandId) {
        this.$router.push({
          name: "adminBrandTraining",
          params: {
            brandId: this.userId,
          },
          query: {
            tab: value,
          },
        });
      } else {
        this.$router.push({
          name: "BrandTraining",
          query: {
            main: true,
            tab: value,
          },
        });
      }
    },
    addNewRetailer() {
      // this.$router.push({
      //   name: this.$route.name,
      //   query: {
      //     ...this.$route.query,
      //     addRetailer: true
      //   }
      // })
      this.isShowPlanStep = true;
    },
    async success() {
      this.isShowPlanStep = false;
      const brandId = this.brand.id ? this.brand.id : this.userId;
      this.tableDate = await this.getRetailersList(brandId);
      this.checkBrandHasGeneralRetailerOrNot();
    },
    initCopyBtn() {
      this.clipboard = new Clipboard("#copyBtn", { text: () => this.copyText });
    },
    jumpToCreateTraining() {
      const haveTrainingList = this.formatProductTableList(
        this.getTrainingProducts
      );
      this.$refs["ProductViewDialogNew"].openProductDialog(
        haveTrainingList,
        this.brand.name,
        this.brand
      );
    },
    openUploadVideo() {
      this.$refs["uploadVideo"].openUploadVideo(this.brand.id);
    },
    clickPagination(value) {
      this.defaultPage = value;
      this.tableDate = this.tableDate.slice(
        (this.defaultPage - 1) * 17,
        this.defaultPage * 17
      );
    },
    SubmitDialog() {
      if (this.$route.params.brandId) {
        this.$router.push({
          name: "adminBrandCatalog",
        });
      } else {
        this.$router.push({
          name: "brandCatalog",
        });
      }
    },
    async sendSuccess() {
      await this.$store.dispatch("brand/getBrand", this.brand.id);
    },
    showSubcribePlanStep() {
      this.isShowPlanStep = true;
      // check whether has general retailer
    },
    checkBrandHasGeneralRetailerOrNot() {
      if (this.tableDate && this.tableDate.length > 0) {
        let gResult = this.tableDate.filter((item) => item.retailerId === "*");
        let pResult = this.tableDate.filter((item) => item.retailerId !== "*");
        if (
          (gResult && gResult.length > 0) ||
          (pResult && pResult.length > 0)
        ) {
          this.hasGeneralRetailer = true;
        } else {
          this.hasGeneralRetailer = false;
        }
      } else {
        this.hasGeneralRetailer = false;
      }
      console.log(this.hasGeneralRetailer);
    },
    addNewRetailerStep() {
      this.isShowPlanStep = true;
      // if (this.isAdmin) {
      //   if (stepValue === 1) {
      //     this.$refs["AddRetailerStepOne"].openDialog()
      //   }
      //   return
      // }
      // if (
      //   this.brand.brandCreditCardInformation &&
      //   this.brand.brandCreditCardInformation.length !== 0
      // ) {
      //   if (stepValue === 1) {
      //     this.$refs["AddRetailerStepOne"].openDialog()
      //   }
      // } else {
      //   this.showAddRetasilerVisible = true
      //   // this.$warning({
      //   //   title: "warning",
      //   //   content: "You have not added your bank card, please add."
      //   // })
      // }
    },
    updateStepStatus(stepValue, stepData) {
      if (stepValue === 1) {
        this.$refs["AddRetailerStepOne"].openDialog();
      } else if (stepValue === 2 && stepData) {
        this.addRetailerSelectArr = stepData;
        this.$refs["AddRetailerStepOne"].closeDialog();
        this.$refs["AddRetailerStepTwo"].openDialog();
      } else if (stepValue === 3 && stepData) {
        this.typeMoney = stepData;
        this.$refs["AddRetailerStepTwo"].closeDialog();
        this.$refs["AddRetailerStepThree"].openDialog(
          this.addRetailerSelectArr,
          this.typeMoney
        );
      }
    },
    backToDialog() {
      this.$refs["AddRetailerStepThree"].closeDialog();
      this.$refs["AddRetailerStepTwo"].openDialog();
    },
    async updateTrainingRetailer(retailerInfo) {
      const brandId = this.brand.id;
      const params = retailerInfo;
      await this.updateRetailer({ brandId, params });
      this.tableDate = await this.getRetailersList(this.brand.id);
      this.checkBrandHasGeneralRetailerOrNot();
    },
    async viewRetailerItemProduct(retailerItem) {
      await this.getProductList(this.userId);
      const list = this.getTrainingProducts;
      this.$refs["retailerItemProduct"].openDialogPro(retailerItem, list);
    },
    async updateRetailerList() {
      this.tableDate = await this.getRetailersList(this.brand.id);
      this.checkBrandHasGeneralRetailerOrNot();
    },
    async updatePaymentTrainingSubscription(arr) {
      if (this.isAdmin) {
        const paymentInfo = {
          type: arr[0].payment,
          amount: arr[0].priceNumber,
          // cardNumber: cardInfo[0].cardNumber,
          retailerId: arr[0].id,
        };
        await this.updatePaymentTrainingSub({
          brandId: this.brand.id,
          payment: paymentInfo,
        });
        this.tableDate = await this.getRetailersList(this.brand.id);
        this.checkBrandHasGeneralRetailerOrNot();
        this.$refs["AddRetailerStepThree"].closeDialog();
        return;
      }
      const cardInfo = this.brand.brandCreditCardInformation.filter(
        (item) => item.default
      );
      const payment = {
        type: arr[0].payment,
        amount: arr[0].priceNumber,
        cardNumber: cardInfo[0].cardNumber,
        retailerId: arr[0].id,
      };
      await this.$store.dispatch("brandPayment/fetchCards", this.brand.id);
      this.$refs["AddRetailerStepThree"].closeDialog();
      this.$refs["addRetailerPurchase"].openCardDialog(
        payment,
        this.addRetailerSelectArr,
        this.typeMoney
      );
    },
    async doPurchase(payment) {
      await this.updatePaymentTrainingSub({ brandId: this.brand.id, payment });
      this.tableDate = await this.getRetailersList(this.brand.id);
      this.checkBrandHasGeneralRetailerOrNot();
    },
    showModalNoInfo(text, id) {
      this.showVisible = true;
      this.contentText = text;
      this.contentLinkId = id;
    },
    handleProductList(product, isNewTraining) {
      this.$refs["modifyRetailerBrandProduct"].openDialog(
        product,
        isNewTraining
      );
    },
    formatProductTableList(list) {
      this.canNotDrag = list.length;
      // let publicList = list.filter(item => item.public && item.training && item.training.published)
      // publicList = publicList.map(value => {
      //   value.publicColor = "#9FD19A"
      //   value.activeText = "View"
      //   return value
      // })
      // let publicFalseList = list.filter(
      //   item => !item.public && item.training && item.training.published
      // )
      // publicFalseList = publicFalseList.map(item => {
      //   item.publicColor = "#F27C59"
      //   item.activeText = "View"
      //   return item
      // })
      // let draftList = list.filter(item => !item.public && item.training && !item.training.published)
      // draftList = draftList.map(item => {
      //   item.publicColor = "#8C8C8C"
      //   item.activeText = "View"
      //   return item
      // })
      // return publicList.concat(publicFalseList).concat(draftList)
      return list.map((item) => {
        // public is true
        if (item.public && item.training && item.training.published) {
          item.publicColor = "#9FD19A";
          item.activeText = "View";
        }
        // public is false
        if (!item.public && item.training && item.training.published) {
          item.publicColor = "#F27C59";
          item.activeText = "View";
        }
        // draft
        if (!item.public && item.training && !item.training.published) {
          item.publicColor = "#8C8C8C";
          item.activeText = "View";
        }
        return item;
      });
    },
    clickToBrandUpgrade() {
      console.log("...click to show upgrade dialog...");
      this.$refs["brandSettingUpgradePlanDialog"].openDialog();
    },
    subscribe(isGeneral, retailerData) {
      console.log(isGeneral);
      console.log(retailerData);
    },
  },
};
</script>

<style scoped lang="scss">
.frame-container {
  height: 100% !important;
}

.brand-training-page__main {
  width: 1200px;
  min-height: 660px;
  margin: 0 auto;

  .brand-training-breadcrumb {
    margin-top: 50px;
    font-size: 20px;
  }

  .training-page-menu {
    margin-top: 40px;
  }

  .training-page-title {
    width: 100%;
    height: 94px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .training-logo {
    font-size: 48px;
    font-weight: bold;
    color: #000000;
    font-family: "Playfair Display";
  }

  .title-button {
    width: 415px;
    text-align: right;
    position: relative;

    //display: flex;
    //justify-content: space-between;
    .btn-style {
      width: 106px;
      height: 30px;
      font-family: "Proxima Nova";
      //line-height: 20px;
      //padding: 5px 16px;
      font-size: 14px;
      border: 2px solid #e1644c;
      border-radius: 7px;
      color: #e1644c;
      background: #ffffff;
    }

    .btn-style:nth-child(2) {
      margin: 0 26px;
      width: 140px;
    }

    .btn-style:nth-child(3) {
      background-color: #e19387;
      border: 2px solid #e19387;
      color: #ffffff;
    }

    .btn-style:hover {
      color: white;
      background: #e1644c;
    }

    .active-share-button {
      background: #9fd19a;
      border-color: #9fd19a;
      color: #ffffff;
    }
  }

  .qr-code-style {
    width: 150px;
    height: 150px;
    margin: 20px auto;
    position: absolute;
    left: 0;
    right: 0;
  }

  .no-data {
    font-size: 16px;
    font-family: "Proxima Nova";
    color: #bfbfbf;
    height: 30px;
    width: 100%;
    margin: 30px 0;
    text-align: center;

    span {
      display: inline-block;
      border: 1px solid #bfbfbf;
      width: 106px;
      height: 30px;
      line-height: 30px;
      border-radius: 3px;
    }
  }

  .no-table-data {
    width: 100%;
    height: 270px;
    text-align: center;
    color: #bfbfbf;
    font-size: 16px;
    padding-top: 80px;
    position: relative;
    left: 350px;
  }

  .editable-row-operations {
    color: #4a8a5d;
  }

  .training-page-table {
    width: 1200px;

    //position: relative;
    .training-table-style {
      overflow: visible;
      width: 100%;
      color: #262626;
      //border: #e8e8e8 solid 1px;
      border-collapse: collapse;
    }

    .training-table-style tr {
      width: 100%;
      position: relative;
    }

    .training-table-style tr:nth-child(2n) {
      background-color: rgba(211, 228, 206, 0.06);
    }

    .training-table-style th {
      border-top: #e8e8e8 solid 1px;
      border-bottom: #e8e8e8 solid 1px;
      padding: 16px;
      //background-color: #fafafa;
      font-size: 14px;
      font-weight: normal;
      color: #262626;
    }

    .training-table-style td {
      height: 56px;
      border-bottom: #e8e8e8 solid 1px;
      padding: 17px 16px;
      background-color: #ffffff;
      color: #595959;
      font-size: 14px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .training-table-style tr,
    .training-table-style td.move:hover {
      cursor: move;
    }

    .training-table-style td.click-pro-action:hover {
      cursor: pointer;
    }

    .name-tab-style {
      position: relative;

      span {
        position: absolute;
        right: 16px;
        top: 15px;
      }
    }

    .data-tab-style {
      //position: relative;
    }
  }

  .tab-box-tr {
    position: absolute;
  }

  .hero-product-position {
    padding: 3px 8px;
    color: #ff6132;
    font-size: 12px;
    background-color: #fef2e2;
    border: 1px solid #ff6132;
    position: absolute;
    left: -1055px;
    top: 15px;
    z-index: 5;
  }

  .draft-info {
    font-size: 12px;
    padding: 3px 8px;
    border: 1px solid #262626;
    background-color: #e8e8e8;
    border-radius: 2px;
    cursor: pointer;
  }

  .delete-btn-style {
    height: 56px;

    p {
      background-color: #d2eeec;
      color: #12433d;
      height: 28px;
      line-height: 28px;
      text-align: center;
      margin-bottom: 0;
    }

    p:hover {
      color: white;
      background-color: #12433d;
    }
  }

  .td-no-padding {
    padding: 0 !important;
  }

  .training-pagination-footer {
    margin-top: 30px;
    text-align: right;
  }

  .ant-btn-primary {
    background-color: #12433d;
  }

  .ant-modal-confirm .ant-modal-confirm-btns {
    text-align: center;
    float: none;
  }

  .dialog-close-btn {
    width: 200px;
    height: 33px;
    line-height: 33px;
    border-radius: 2px;
    font-size: 14px;
    margin-top: 27px;
    background-color: #12433d;
    color: white;
    text-align: center;
    margin-left: 110px;
    cursor: pointer;
  }

  .dialog-close-btn:hover {
    background-color: #4a8a5d;
    color: #ffffff;
  }

  .product-hero-style {
    display: inline-block;
    width: 39px;
    height: 22px;
    line-height: 22px;
    background: #f3ca50;
    color: #ffffff;
    border-radius: 100px;
    text-align: center;
  }

  .can-not-create-training {
    padding: 15px;
    text-align: left;
    font-size: 15px;

    .title-error-text {
      font-weight: bold;
    }

    .button-style {
      text-align: right;
    }

    .btn-style {
      background: #9fd19a;
      border: 1px solid #9fd19a;
      color: #ffffff;
    }

    .btn-style:hover {
      background: #4a8a5d;
      border: 1px solid #4a8a5d;
      color: #ffffff;
    }
  }

  .icon-sort-style {
    color: #8c8c8c;
  }
}

.ant-breadcrumb {
  font-size: 20px;
}

.ant-pagination-item-active {
  border-color: #4a8a5d;
}

.ant-switch-checked {
  background-color: #9fd19a;
}

.ant-modal-confirm-title {
  text-align: center;
}

.info-dialog-main {
  text-align: center;
  background-color: yellow;
}

.dialog-info-before-submit {
  //width: 236px;在·
  text-align: center;
  color: #12433d;
  font-size: 13px;
  //margin-left: 77px;
  margin-top: 23px;
  font-family: "Proxima Nova", "Roboto", sans-serif;
}

.dialog-info-title {
  text-align: center;
  font-size: 16px;
  margin-bottom: 23px;
}

.training-table-style tr:hover {
  .drag-three-circular {
    position: absolute;

    .three-circular {
      position: relative;
      width: 28px;
      height: 28px;
      color: #595959;
      //margin: 50px;
      left: -971px;
      top: 15px;
      z-index: 5;
    }

    .three-circular:after {
      content: "•••";
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%) rotate(90deg);
      font-size: 12px;
      letter-spacing: 2px;
      margin-top: 2px;
    }
  }
}
</style>
